module.exports = __webpack_public_path__ + "img/discord.872a595c.png";